import { jsonp, ajax } from '@ifeng-fe/ui_base';
import md5 from 'md5';
import axios from 'axios';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;
/* eslint-enable no-undef */

if (typeof window !== 'undefined' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/api';
}

// jsonp 接口请求示例 ---- start (开发时请删除示例代码)
// jsonp 接口请求示例 ---- start (开发时请删除示例代码)
// jsonp 接口请求示例 ---- start (开发时请删除示例代码)
const getWeatherData = async (city) => {
    return await jsonp(`https://api.iclient.ifeng.com/newH5Weather?key=weather&value=${city}`);
};

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    /* eslint-disable */
    while (typeof window === 'object' && window[jsonpCallbackName]) {
        /* eslint-enable */
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

const getMyStockData = async (num) => {
    return await jsonp('//apiapp.finance.ifeng.com/mystock/get', {
        data: { num },
        jsonpCallback: createJsonpCallbackName('getMyStockData'),
        cache: false,
    });
};

const getTokenData = async (type) => {
    const timeStamp = new Date().getTime();

    return await ajax(`https://d.shankapi.ifeng.com/api/phtv/host/sign/uplaod/${type}/token/${timeStamp}`);
};

const saveMediaFile = async (type, data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv/host/sign/${type}/commit/${timeStamp}`, data);
};

const getVideoFileKey = async (url, formData, onUploadProgress) => {
    return await axios.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        onUploadProgress,
    });
};

const getImgFileKey = async (url, formData) => {
    return await axios.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

const submitFormHandle = async (data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv/host/sign/commit/${timeStamp}`, data);
};

const getTokenData2024 = async (type) => {
    const timeStamp = new Date().getTime();

    return await ajax(`https://d.shankapi.ifeng.com/api/phtv2024/host/sign/upload/${type}/token/${timeStamp}`);
};

const saveMediaFile2024 = async (type, data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2024/host/sign/${type}/commit/${timeStamp}`, data);
};

const submitFormHandle2024 = async (data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2024/host/sign/commit/${timeStamp}`, data);
};

const updateFormHandle2024 = async (data, updateId) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2024/host/sign/${updateId}/update/${timeStamp}`, data);
};

const getHostHandle2024 = async (updataId) => {
    const timeStamp = new Date().getTime();

    return await axios.get(`https://shankapi.ifeng.com/api/phtv2024/host/sign/get/${updataId}/info/${timeStamp}`);
};

const getTokenDataHK2024 = async (type) => {
    const timeStamp = new Date().getTime();

    return await ajax(`https://d.shankapi.ifeng.com/api/phtv2024/hk/host/sign/upload/${type}/token/${timeStamp}`);
};

const saveMediaFileHK2024 = async (type, data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2024/hk/host/sign/${type}/commit/${timeStamp}`, data);
};

const submitFormHandleHK2024 = async (data) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2024/hk/host/sign/commit/${timeStamp}`, data);
};

const updateFormHandleHK2024 = async (data, updateId) => {
    const timeStamp = new Date().getTime();

    return await axios.post(`https://d.shankapi.ifeng.com/api/phtv2024/hk/host/sign/${updateId}/update/${timeStamp}`, data);
};

const getHostHandleHK2024 = async (updataId) => {
    const timeStamp = new Date().getTime();

    return await axios.get(`https://shankapi.ifeng.com/api/phtv2024/hk/host/sign/get/${updataId}/info/${timeStamp}`);
};

// jsonp 接口请求示例 ---- end  (开发时请删除示例代码)
// jsonp 接口请求示例 ---- end  (开发时请删除示例代码)
// jsonp 接口请求示例 ---- end  (开发时请删除示例代码)

export {
    getTokenDataHK2024,
    saveMediaFileHK2024,
    submitFormHandleHK2024,
    updateFormHandleHK2024,
    getHostHandleHK2024,
    getMyStockData,
    getWeatherData,
    getTokenData,
    getImgFileKey,
    getVideoFileKey,
    submitFormHandle,
    saveMediaFile,
    getTokenData2024,
    saveMediaFile2024,
    submitFormHandle2024,
    getHostHandle2024,
    updateFormHandle2024
};
